import { Extension } from 'tiptap'
import QuesAppointComponent from './quesAppointComponent'
// 自定义高级编辑组件
export default class QuesAppoint extends Extension {
    // here you can extend the extension like tiptap, such as schema, plugins ...
    get name() {
      return 'QuesAppoint';
    }
    commands() {
      return (text) => (state, dispatch) => {
        let tr = state.tr.insertText(text)
        dispatch(tr);
        return true;
      };
    }
    menuBtnView ({ isActive, commands, focus, editor }) {
        return {
            component: QuesAppointComponent,
            componentProps: {
                citableQuesList: this.options.citableQuesList
            },
            componentEvents: {
                click: (text='') => {
                    commands.QuesAppoint(text)
                },
                },
            };
        }
  }